export default __webpack_public_path__ + "static/media/school-room.097057ac.svg";